/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();

var core_pb = require('./core_pb.js');

goog.object.extend(proto, core_pb);
goog.exportSymbol('proto.bcsdk.CurrentWork', null, global);
goog.exportSymbol('proto.bcsdk.GetBalanceRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetBalanceResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetBlake2blRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetBlake2blResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetBlockHashRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetBlockHeightRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetBlocksRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetBlocksResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetHistoricalOrdersResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetHistoryRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetMarkedTxRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetMatchedOrdersResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetOpenOrdersResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetOutPointRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetOutPointStatusResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetRawMempoolResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetRoveredBlockHashRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetRoveredBlockHeightRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetRoveredBlocksRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetRoveredBlocksResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetSpendableCollateralRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetSpendableCollateralResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetTradeStatusResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetTxRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetUnlockTakerTxParamsRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetUnlockTakerTxParamsResponse', null, global);
goog.exportSymbol('proto.bcsdk.GetUtxoLengthRequest', null, global);
goog.exportSymbol('proto.bcsdk.GetUtxoLengthResponse', null, global);
goog.exportSymbol('proto.bcsdk.HelpResponse', null, global);
goog.exportSymbol('proto.bcsdk.MakerOrderInfo', null, global);
goog.exportSymbol('proto.bcsdk.MatchedOrderInfo', null, global);
goog.exportSymbol('proto.bcsdk.RpcTransaction', null, global);
goog.exportSymbol('proto.bcsdk.RpcTransactionResponse', null, global);
goog.exportSymbol('proto.bcsdk.RpcTransactionResponseStatus', null, global);
goog.exportSymbol('proto.bcsdk.SettingsResponse', null, global);
goog.exportSymbol('proto.bcsdk.StatsResponse', null, global);
goog.exportSymbol('proto.bcsdk.SyncStatus', null, global);
goog.exportSymbol('proto.bcsdk.TakerOrder', null, global);
goog.exportSymbol('proto.bcsdk.TakerOrderInfo', null, global);
goog.exportSymbol('proto.bcsdk.Transfer', null, global);
goog.exportSymbol('proto.bcsdk.TransferRequest', null, global);
goog.exportSymbol('proto.bcsdk.TransferResponse', null, global);
goog.exportSymbol('proto.bcsdk.VanityConvertRequest', null, global);
goog.exportSymbol('proto.bcsdk.VanityConvertResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.bcsdk.HelpResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.HelpResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.HelpResponse.displayName = 'proto.bcsdk.HelpResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.HelpResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.HelpResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.HelpResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.HelpResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      helpText: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.HelpResponse}
 */


proto.bcsdk.HelpResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.HelpResponse();
  return proto.bcsdk.HelpResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.HelpResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.HelpResponse}
 */


proto.bcsdk.HelpResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHelpText(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.HelpResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.HelpResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.HelpResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.HelpResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHelpText();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string help_text = 1;
 * @return {string}
 */


proto.bcsdk.HelpResponse.prototype.getHelpText = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.HelpResponse.prototype.setHelpText = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.StatsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.StatsResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.StatsResponse.displayName = 'proto.bcsdk.StatsResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.StatsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.StatsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.StatsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.StatsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      calls: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.StatsResponse}
 */


proto.bcsdk.StatsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.StatsResponse();
  return proto.bcsdk.StatsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.StatsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.StatsResponse}
 */


proto.bcsdk.StatsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt64();
        msg.setCalls(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.StatsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.StatsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.StatsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.StatsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCalls();

  if (f !== 0) {
    writer.writeInt64(1, f);
  }
};
/**
 * optional int64 calls = 1;
 * @return {number}
 */


proto.bcsdk.StatsResponse.prototype.getCalls = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.bcsdk.StatsResponse.prototype.setCalls = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.RpcTransaction = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.RpcTransaction, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.RpcTransaction.displayName = 'proto.bcsdk.RpcTransaction';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.RpcTransaction.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.RpcTransaction.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.RpcTransaction} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.RpcTransaction.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      fromAddr: jspb.Message.getFieldWithDefault(msg, 1, ""),
      toAddr: jspb.Message.getFieldWithDefault(msg, 2, ""),
      amount: jspb.Message.getFieldWithDefault(msg, 3, ""),
      txFee: jspb.Message.getFieldWithDefault(msg, 4, ""),
      privateKeyHex: jspb.Message.getFieldWithDefault(msg, 5, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.RpcTransaction}
 */


proto.bcsdk.RpcTransaction.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.RpcTransaction();
  return proto.bcsdk.RpcTransaction.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.RpcTransaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.RpcTransaction}
 */


proto.bcsdk.RpcTransaction.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setFromAddr(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setToAddr(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAmount(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTxFee(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPrivateKeyHex(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.RpcTransaction.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.RpcTransaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.RpcTransaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.RpcTransaction.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getFromAddr();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getToAddr();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getAmount();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getTxFee();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getPrivateKeyHex();

  if (f.length > 0) {
    writer.writeString(5, f);
  }
};
/**
 * optional string from_addr = 1;
 * @return {string}
 */


proto.bcsdk.RpcTransaction.prototype.getFromAddr = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.RpcTransaction.prototype.setFromAddr = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string to_addr = 2;
 * @return {string}
 */


proto.bcsdk.RpcTransaction.prototype.getToAddr = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.RpcTransaction.prototype.setToAddr = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string amount = 3;
 * @return {string}
 */


proto.bcsdk.RpcTransaction.prototype.getAmount = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.RpcTransaction.prototype.setAmount = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string tx_fee = 4;
 * @return {string}
 */


proto.bcsdk.RpcTransaction.prototype.getTxFee = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.bcsdk.RpcTransaction.prototype.setTxFee = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string private_key_hex = 5;
 * @return {string}
 */


proto.bcsdk.RpcTransaction.prototype.getPrivateKeyHex = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.bcsdk.RpcTransaction.prototype.setPrivateKeyHex = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.RpcTransactionResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.RpcTransactionResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.RpcTransactionResponse.displayName = 'proto.bcsdk.RpcTransactionResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.RpcTransactionResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.RpcTransactionResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.RpcTransactionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.RpcTransactionResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      status: jspb.Message.getFieldWithDefault(msg, 1, 0),
      txHash: jspb.Message.getFieldWithDefault(msg, 2, ""),
      error: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.RpcTransactionResponse}
 */


proto.bcsdk.RpcTransactionResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.RpcTransactionResponse();
  return proto.bcsdk.RpcTransactionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.RpcTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.RpcTransactionResponse}
 */


proto.bcsdk.RpcTransactionResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.bcsdk.RpcTransactionResponseStatus} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTxHash(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setError(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.RpcTransactionResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.RpcTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.RpcTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.RpcTransactionResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }

  f = message.getTxHash();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getError();

  if (f.length > 0) {
    writer.writeString(3, f);
  }
};
/**
 * optional RpcTransactionResponseStatus status = 1;
 * @return {!proto.bcsdk.RpcTransactionResponseStatus}
 */


proto.bcsdk.RpcTransactionResponse.prototype.getStatus = function () {
  return (
    /** @type {!proto.bcsdk.RpcTransactionResponseStatus} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.bcsdk.RpcTransactionResponseStatus} value */


proto.bcsdk.RpcTransactionResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string tx_hash = 2;
 * @return {string}
 */


proto.bcsdk.RpcTransactionResponse.prototype.getTxHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.RpcTransactionResponse.prototype.setTxHash = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string error = 3;
 * @return {string}
 */


proto.bcsdk.RpcTransactionResponse.prototype.getError = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.RpcTransactionResponse.prototype.setError = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.Transfer = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.Transfer, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.Transfer.displayName = 'proto.bcsdk.Transfer';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.Transfer.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.Transfer.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.Transfer} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.Transfer.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      from: jspb.Message.getFieldWithDefault(msg, 1, ""),
      to: jspb.Message.getFieldWithDefault(msg, 2, ""),
      amount: jspb.Message.getFieldWithDefault(msg, 3, ""),
      txHash: jspb.Message.getFieldWithDefault(msg, 4, ""),
      txOutputIndex: jspb.Message.getFieldWithDefault(msg, 5, 0),
      timestamp: jspb.Message.getFieldWithDefault(msg, 6, 0),
      height: jspb.Message.getFieldWithDefault(msg, 7, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.Transfer}
 */


proto.bcsdk.Transfer.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.Transfer();
  return proto.bcsdk.Transfer.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.Transfer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.Transfer}
 */


proto.bcsdk.Transfer.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setFrom(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTo(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAmount(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTxHash(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setTxOutputIndex(value);
        break;

      case 6:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTimestamp(value);
        break;

      case 7:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setHeight(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.Transfer.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.Transfer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.Transfer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.Transfer.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getFrom();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getTo();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getAmount();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getTxHash();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getTxOutputIndex();

  if (f !== 0) {
    writer.writeUint32(5, f);
  }

  f = message.getTimestamp();

  if (f !== 0) {
    writer.writeUint64(6, f);
  }

  f = message.getHeight();

  if (f !== 0) {
    writer.writeUint64(7, f);
  }
};
/**
 * optional string from = 1;
 * @return {string}
 */


proto.bcsdk.Transfer.prototype.getFrom = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.Transfer.prototype.setFrom = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string to = 2;
 * @return {string}
 */


proto.bcsdk.Transfer.prototype.getTo = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.Transfer.prototype.setTo = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string amount = 3;
 * @return {string}
 */


proto.bcsdk.Transfer.prototype.getAmount = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.Transfer.prototype.setAmount = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string tx_hash = 4;
 * @return {string}
 */


proto.bcsdk.Transfer.prototype.getTxHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.bcsdk.Transfer.prototype.setTxHash = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional uint32 tx_output_index = 5;
 * @return {number}
 */


proto.bcsdk.Transfer.prototype.getTxOutputIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Transfer.prototype.setTxOutputIndex = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional uint64 timestamp = 6;
 * @return {number}
 */


proto.bcsdk.Transfer.prototype.getTimestamp = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Transfer.prototype.setTimestamp = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional uint64 height = 7;
 * @return {number}
 */


proto.bcsdk.Transfer.prototype.getHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/** @param {number} value */


proto.bcsdk.Transfer.prototype.setHeight = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.TransferRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.TransferRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.TransferRequest.displayName = 'proto.bcsdk.TransferRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.TransferRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.TransferRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.TransferRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.TransferRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      address: jspb.Message.getFieldWithDefault(msg, 1, ""),
      max: jspb.Message.getFieldWithDefault(msg, 2, 0),
      from: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.TransferRequest}
 */


proto.bcsdk.TransferRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.TransferRequest();
  return proto.bcsdk.TransferRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.TransferRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.TransferRequest}
 */


proto.bcsdk.TransferRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAddress(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setMax(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setFrom(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.TransferRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.TransferRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.TransferRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.TransferRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAddress();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getMax();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }

  f = message.getFrom();

  if (f.length > 0) {
    writer.writeString(3, f);
  }
};
/**
 * optional string address = 1;
 * @return {string}
 */


proto.bcsdk.TransferRequest.prototype.getAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.TransferRequest.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 max = 2;
 * @return {number}
 */


proto.bcsdk.TransferRequest.prototype.getMax = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.TransferRequest.prototype.setMax = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string from = 3;
 * @return {string}
 */


proto.bcsdk.TransferRequest.prototype.getFrom = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.TransferRequest.prototype.setFrom = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetHistoryRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetHistoryRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetHistoryRequest.displayName = 'proto.bcsdk.GetHistoryRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetHistoryRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetHistoryRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetHistoryRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetHistoryRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      from: jspb.Message.getFieldWithDefault(msg, 1, ""),
      max: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetHistoryRequest}
 */


proto.bcsdk.GetHistoryRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetHistoryRequest();
  return proto.bcsdk.GetHistoryRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetHistoryRequest}
 */


proto.bcsdk.GetHistoryRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setFrom(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setMax(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetHistoryRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetHistoryRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getFrom();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getMax();

  if (f !== 0) {
    writer.writeUint64(2, f);
  }
};
/**
 * optional string from = 1;
 * @return {string}
 */


proto.bcsdk.GetHistoryRequest.prototype.getFrom = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetHistoryRequest.prototype.setFrom = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint64 max = 2;
 * @return {number}
 */


proto.bcsdk.GetHistoryRequest.prototype.getMax = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetHistoryRequest.prototype.setMax = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.TransferResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.TransferResponse.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.TransferResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.TransferResponse.displayName = 'proto.bcsdk.TransferResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.TransferResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.TransferResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.TransferResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.TransferResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.TransferResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      transfersList: jspb.Message.toObjectList(msg.getTransfersList(), proto.bcsdk.Transfer.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.TransferResponse}
 */


proto.bcsdk.TransferResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.TransferResponse();
  return proto.bcsdk.TransferResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.TransferResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.TransferResponse}
 */


proto.bcsdk.TransferResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.Transfer();
        reader.readMessage(value, proto.bcsdk.Transfer.deserializeBinaryFromReader);
        msg.addTransfers(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.TransferResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.TransferResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.TransferResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.TransferResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTransfersList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.bcsdk.Transfer.serializeBinaryToWriter);
  }
};
/**
 * repeated Transfer transfers = 1;
 * @return {!Array<!proto.bcsdk.Transfer>}
 */


proto.bcsdk.TransferResponse.prototype.getTransfersList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.Transfer>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.Transfer, 1)
  );
};
/** @param {!Array<!proto.bcsdk.Transfer>} value */


proto.bcsdk.TransferResponse.prototype.setTransfersList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.bcsdk.Transfer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.Transfer}
 */


proto.bcsdk.TransferResponse.prototype.addTransfers = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.bcsdk.Transfer, opt_index);
};

proto.bcsdk.TransferResponse.prototype.clearTransfersList = function () {
  this.setTransfersList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetUtxoLengthRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetUtxoLengthRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetUtxoLengthRequest.displayName = 'proto.bcsdk.GetUtxoLengthRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetUtxoLengthRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetUtxoLengthRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetUtxoLengthRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetUtxoLengthRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      scriptType: jspb.Message.getFieldWithDefault(msg, 1, ""),
      address: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetUtxoLengthRequest}
 */


proto.bcsdk.GetUtxoLengthRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetUtxoLengthRequest();
  return proto.bcsdk.GetUtxoLengthRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetUtxoLengthRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetUtxoLengthRequest}
 */


proto.bcsdk.GetUtxoLengthRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setScriptType(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAddress(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetUtxoLengthRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetUtxoLengthRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetUtxoLengthRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetUtxoLengthRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getScriptType();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getAddress();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string script_type = 1;
 * @return {string}
 */


proto.bcsdk.GetUtxoLengthRequest.prototype.getScriptType = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetUtxoLengthRequest.prototype.setScriptType = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string address = 2;
 * @return {string}
 */


proto.bcsdk.GetUtxoLengthRequest.prototype.getAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetUtxoLengthRequest.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetUtxoLengthResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetUtxoLengthResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetUtxoLengthResponse.displayName = 'proto.bcsdk.GetUtxoLengthResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetUtxoLengthResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetUtxoLengthResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetUtxoLengthResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetUtxoLengthResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      length: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetUtxoLengthResponse}
 */


proto.bcsdk.GetUtxoLengthResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetUtxoLengthResponse();
  return proto.bcsdk.GetUtxoLengthResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetUtxoLengthResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetUtxoLengthResponse}
 */


proto.bcsdk.GetUtxoLengthResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setLength(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetUtxoLengthResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetUtxoLengthResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetUtxoLengthResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetUtxoLengthResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLength();

  if (f !== 0) {
    writer.writeUint32(1, f);
  }
};
/**
 * optional uint32 length = 1;
 * @return {number}
 */


proto.bcsdk.GetUtxoLengthResponse.prototype.getLength = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetUtxoLengthResponse.prototype.setLength = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetSpendableCollateralRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetSpendableCollateralRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetSpendableCollateralRequest.displayName = 'proto.bcsdk.GetSpendableCollateralRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetSpendableCollateralRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetSpendableCollateralRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetSpendableCollateralRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetSpendableCollateralRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      address: jspb.Message.getFieldWithDefault(msg, 1, ""),
      from: jspb.Message.getFieldWithDefault(msg, 2, 0),
      to: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetSpendableCollateralRequest}
 */


proto.bcsdk.GetSpendableCollateralRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetSpendableCollateralRequest();
  return proto.bcsdk.GetSpendableCollateralRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetSpendableCollateralRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetSpendableCollateralRequest}
 */


proto.bcsdk.GetSpendableCollateralRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAddress(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setFrom(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setTo(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetSpendableCollateralRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetSpendableCollateralRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetSpendableCollateralRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetSpendableCollateralRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAddress();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getFrom();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }

  f = message.getTo();

  if (f !== 0) {
    writer.writeUint32(3, f);
  }
};
/**
 * optional string address = 1;
 * @return {string}
 */


proto.bcsdk.GetSpendableCollateralRequest.prototype.getAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetSpendableCollateralRequest.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 from = 2;
 * @return {number}
 */


proto.bcsdk.GetSpendableCollateralRequest.prototype.getFrom = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetSpendableCollateralRequest.prototype.setFrom = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint32 to = 3;
 * @return {number}
 */


proto.bcsdk.GetSpendableCollateralRequest.prototype.getTo = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetSpendableCollateralRequest.prototype.setTo = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetSpendableCollateralResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.GetSpendableCollateralResponse.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.GetSpendableCollateralResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetSpendableCollateralResponse.displayName = 'proto.bcsdk.GetSpendableCollateralResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.GetSpendableCollateralResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetSpendableCollateralResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetSpendableCollateralResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetSpendableCollateralResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetSpendableCollateralResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      outpointsList: jspb.Message.toObjectList(msg.getOutpointsList(), core_pb.OutPoint.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetSpendableCollateralResponse}
 */


proto.bcsdk.GetSpendableCollateralResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetSpendableCollateralResponse();
  return proto.bcsdk.GetSpendableCollateralResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetSpendableCollateralResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetSpendableCollateralResponse}
 */


proto.bcsdk.GetSpendableCollateralResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new core_pb.OutPoint();
        reader.readMessage(value, core_pb.OutPoint.deserializeBinaryFromReader);
        msg.addOutpoints(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetSpendableCollateralResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetSpendableCollateralResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetSpendableCollateralResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetSpendableCollateralResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOutpointsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, core_pb.OutPoint.serializeBinaryToWriter);
  }
};
/**
 * repeated OutPoint outpoints = 1;
 * @return {!Array<!proto.bcsdk.OutPoint>}
 */


proto.bcsdk.GetSpendableCollateralResponse.prototype.getOutpointsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.OutPoint>} */
    jspb.Message.getRepeatedWrapperField(this, core_pb.OutPoint, 1)
  );
};
/** @param {!Array<!proto.bcsdk.OutPoint>} value */


proto.bcsdk.GetSpendableCollateralResponse.prototype.setOutpointsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.bcsdk.OutPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.OutPoint}
 */


proto.bcsdk.GetSpendableCollateralResponse.prototype.addOutpoints = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.bcsdk.OutPoint, opt_index);
};

proto.bcsdk.GetSpendableCollateralResponse.prototype.clearOutpointsList = function () {
  this.setOutpointsList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetBalanceRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetBalanceRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetBalanceRequest.displayName = 'proto.bcsdk.GetBalanceRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetBalanceRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetBalanceRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetBalanceRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetBalanceRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      address: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetBalanceRequest}
 */


proto.bcsdk.GetBalanceRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetBalanceRequest();
  return proto.bcsdk.GetBalanceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetBalanceRequest}
 */


proto.bcsdk.GetBalanceRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setAddress(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetBalanceRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetBalanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetBalanceRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getAddress();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string address = 1;
 * @return {string}
 */


proto.bcsdk.GetBalanceRequest.prototype.getAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetBalanceRequest.prototype.setAddress = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetBalanceResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetBalanceResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetBalanceResponse.displayName = 'proto.bcsdk.GetBalanceResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetBalanceResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetBalanceResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetBalanceResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetBalanceResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      height: jspb.Message.getFieldWithDefault(msg, 1, 0),
      confirmed: jspb.Message.getFieldWithDefault(msg, 2, ""),
      unconfirmed: jspb.Message.getFieldWithDefault(msg, 3, ""),
      collateralized: jspb.Message.getFieldWithDefault(msg, 4, ""),
      unlockable: jspb.Message.getFieldWithDefault(msg, 5, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetBalanceResponse}
 */


proto.bcsdk.GetBalanceResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetBalanceResponse();
  return proto.bcsdk.GetBalanceResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetBalanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetBalanceResponse}
 */


proto.bcsdk.GetBalanceResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setHeight(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setConfirmed(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setUnconfirmed(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCollateralized(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setUnlockable(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetBalanceResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetBalanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetBalanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetBalanceResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHeight();

  if (f !== 0) {
    writer.writeUint32(1, f);
  }

  f = message.getConfirmed();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getUnconfirmed();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getCollateralized();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getUnlockable();

  if (f.length > 0) {
    writer.writeString(5, f);
  }
};
/**
 * optional uint32 height = 1;
 * @return {number}
 */


proto.bcsdk.GetBalanceResponse.prototype.getHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetBalanceResponse.prototype.setHeight = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string confirmed = 2;
 * @return {string}
 */


proto.bcsdk.GetBalanceResponse.prototype.getConfirmed = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetBalanceResponse.prototype.setConfirmed = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string unconfirmed = 3;
 * @return {string}
 */


proto.bcsdk.GetBalanceResponse.prototype.getUnconfirmed = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetBalanceResponse.prototype.setUnconfirmed = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string collateralized = 4;
 * @return {string}
 */


proto.bcsdk.GetBalanceResponse.prototype.getCollateralized = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetBalanceResponse.prototype.setCollateralized = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string unlockable = 5;
 * @return {string}
 */


proto.bcsdk.GetBalanceResponse.prototype.getUnlockable = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetBalanceResponse.prototype.setUnlockable = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetUnlockTakerTxParamsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetUnlockTakerTxParamsRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetUnlockTakerTxParamsRequest.displayName = 'proto.bcsdk.GetUnlockTakerTxParamsRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetUnlockTakerTxParamsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetUnlockTakerTxParamsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetUnlockTakerTxParamsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetUnlockTakerTxParamsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      txHash: jspb.Message.getFieldWithDefault(msg, 1, ""),
      txOutputIndex: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetUnlockTakerTxParamsRequest}
 */


proto.bcsdk.GetUnlockTakerTxParamsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetUnlockTakerTxParamsRequest();
  return proto.bcsdk.GetUnlockTakerTxParamsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetUnlockTakerTxParamsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetUnlockTakerTxParamsRequest}
 */


proto.bcsdk.GetUnlockTakerTxParamsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTxHash(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setTxOutputIndex(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetUnlockTakerTxParamsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetUnlockTakerTxParamsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetUnlockTakerTxParamsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetUnlockTakerTxParamsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTxHash();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getTxOutputIndex();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }
};
/**
 * optional string tx_hash = 1;
 * @return {string}
 */


proto.bcsdk.GetUnlockTakerTxParamsRequest.prototype.getTxHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetUnlockTakerTxParamsRequest.prototype.setTxHash = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 tx_output_index = 2;
 * @return {number}
 */


proto.bcsdk.GetUnlockTakerTxParamsRequest.prototype.getTxOutputIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetUnlockTakerTxParamsRequest.prototype.setTxOutputIndex = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.GetUnlockTakerTxParamsResponse.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.GetUnlockTakerTxParamsResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetUnlockTakerTxParamsResponse.displayName = 'proto.bcsdk.GetUnlockTakerTxParamsResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetUnlockTakerTxParamsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetUnlockTakerTxParamsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetUnlockTakerTxParamsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetUnlockTakerTxParamsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      unlockScriptsList: jspb.Message.getRepeatedField(msg, 1),
      valueInTx: msg.getValueInTx_asB64()
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetUnlockTakerTxParamsResponse}
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetUnlockTakerTxParamsResponse();
  return proto.bcsdk.GetUnlockTakerTxParamsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetUnlockTakerTxParamsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetUnlockTakerTxParamsResponse}
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addUnlockScripts(value);
        break;

      case 2:
        var value =
        /** @type {!Uint8Array} */
        reader.readBytes();
        msg.setValueInTx(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetUnlockTakerTxParamsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetUnlockTakerTxParamsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUnlockScriptsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }

  f = message.getValueInTx_asU8();

  if (f.length > 0) {
    writer.writeBytes(2, f);
  }
};
/**
 * repeated string unlock_scripts = 1;
 * @return {!Array<string>}
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse.prototype.getUnlockScriptsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.bcsdk.GetUnlockTakerTxParamsResponse.prototype.setUnlockScriptsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse.prototype.addUnlockScripts = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};

proto.bcsdk.GetUnlockTakerTxParamsResponse.prototype.clearUnlockScriptsList = function () {
  this.setUnlockScriptsList([]);
};
/**
 * optional bytes value_in_tx = 2;
 * @return {!(string|Uint8Array)}
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse.prototype.getValueInTx = function () {
  return (
    /** @type {!(string|Uint8Array)} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * optional bytes value_in_tx = 2;
 * This is a type-conversion wrapper around `getValueInTx()`
 * @return {string}
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse.prototype.getValueInTx_asB64 = function () {
  return (
    /** @type {string} */
    jspb.Message.bytesAsB64(this.getValueInTx())
  );
};
/**
 * optional bytes value_in_tx = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValueInTx()`
 * @return {!Uint8Array}
 */


proto.bcsdk.GetUnlockTakerTxParamsResponse.prototype.getValueInTx_asU8 = function () {
  return (
    /** @type {!Uint8Array} */
    jspb.Message.bytesAsU8(this.getValueInTx())
  );
};
/** @param {!(string|Uint8Array)} value */


proto.bcsdk.GetUnlockTakerTxParamsResponse.prototype.setValueInTx = function (value) {
  jspb.Message.setProto3BytesField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.MakerOrderInfo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.MakerOrderInfo, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.MakerOrderInfo.displayName = 'proto.bcsdk.MakerOrderInfo';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.MakerOrderInfo.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.MakerOrderInfo.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.MakerOrderInfo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.MakerOrderInfo.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      tradeHeight: jspb.Message.getFieldWithDefault(msg, 1, 0),
      deposit: jspb.Message.getFieldWithDefault(msg, 2, 0),
      settlement: jspb.Message.getFieldWithDefault(msg, 3, 0),
      shiftMaker: jspb.Message.getFieldWithDefault(msg, 4, 0),
      shiftTaker: jspb.Message.getFieldWithDefault(msg, 5, 0),
      sendsFromChain: jspb.Message.getFieldWithDefault(msg, 6, ""),
      receivesToChain: jspb.Message.getFieldWithDefault(msg, 7, ""),
      sendsFromAddress: jspb.Message.getFieldWithDefault(msg, 8, ""),
      receivesToAddress: jspb.Message.getFieldWithDefault(msg, 9, ""),
      sendsUnit: jspb.Message.getFieldWithDefault(msg, 10, ""),
      receivesUnit: jspb.Message.getFieldWithDefault(msg, 11, ""),
      doubleHashedBcAddress: jspb.Message.getFieldWithDefault(msg, 12, ""),
      collateralizedNrg: jspb.Message.getFieldWithDefault(msg, 13, ""),
      originalNrg: jspb.Message.getFieldWithDefault(msg, 14, ""),
      nrgUnit: jspb.Message.getFieldWithDefault(msg, 15, ""),
      txHash: jspb.Message.getFieldWithDefault(msg, 16, ""),
      txOutputIndex: jspb.Message.getFieldWithDefault(msg, 17, 0),
      isSettled: jspb.Message.getFieldWithDefault(msg, 18, false),
      fixedUnitFee: jspb.Message.getFieldWithDefault(msg, 19, ""),
      base: jspb.Message.getFieldWithDefault(msg, 20, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.MakerOrderInfo}
 */


proto.bcsdk.MakerOrderInfo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.MakerOrderInfo();
  return proto.bcsdk.MakerOrderInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.MakerOrderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.MakerOrderInfo}
 */


proto.bcsdk.MakerOrderInfo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTradeHeight(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setDeposit(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setSettlement(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setShiftMaker(value);
        break;

      case 5:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setShiftTaker(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSendsFromChain(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setReceivesToChain(value);
        break;

      case 8:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSendsFromAddress(value);
        break;

      case 9:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setReceivesToAddress(value);
        break;

      case 10:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSendsUnit(value);
        break;

      case 11:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setReceivesUnit(value);
        break;

      case 12:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDoubleHashedBcAddress(value);
        break;

      case 13:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCollateralizedNrg(value);
        break;

      case 14:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setOriginalNrg(value);
        break;

      case 15:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setNrgUnit(value);
        break;

      case 16:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTxHash(value);
        break;

      case 17:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setTxOutputIndex(value);
        break;

      case 18:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsSettled(value);
        break;

      case 19:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setFixedUnitFee(value);
        break;

      case 20:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setBase(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.MakerOrderInfo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.MakerOrderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.MakerOrderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.MakerOrderInfo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTradeHeight();

  if (f !== 0) {
    writer.writeUint64(1, f);
  }

  f = message.getDeposit();

  if (f !== 0) {
    writer.writeUint64(2, f);
  }

  f = message.getSettlement();

  if (f !== 0) {
    writer.writeUint64(3, f);
  }

  f = message.getShiftMaker();

  if (f !== 0) {
    writer.writeUint64(4, f);
  }

  f = message.getShiftTaker();

  if (f !== 0) {
    writer.writeUint64(5, f);
  }

  f = message.getSendsFromChain();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getReceivesToChain();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getSendsFromAddress();

  if (f.length > 0) {
    writer.writeString(8, f);
  }

  f = message.getReceivesToAddress();

  if (f.length > 0) {
    writer.writeString(9, f);
  }

  f = message.getSendsUnit();

  if (f.length > 0) {
    writer.writeString(10, f);
  }

  f = message.getReceivesUnit();

  if (f.length > 0) {
    writer.writeString(11, f);
  }

  f = message.getDoubleHashedBcAddress();

  if (f.length > 0) {
    writer.writeString(12, f);
  }

  f = message.getCollateralizedNrg();

  if (f.length > 0) {
    writer.writeString(13, f);
  }

  f = message.getOriginalNrg();

  if (f.length > 0) {
    writer.writeString(14, f);
  }

  f = message.getNrgUnit();

  if (f.length > 0) {
    writer.writeString(15, f);
  }

  f = message.getTxHash();

  if (f.length > 0) {
    writer.writeString(16, f);
  }

  f = message.getTxOutputIndex();

  if (f !== 0) {
    writer.writeUint32(17, f);
  }

  f = message.getIsSettled();

  if (f) {
    writer.writeBool(18, f);
  }

  f = message.getFixedUnitFee();

  if (f.length > 0) {
    writer.writeString(19, f);
  }

  f = message.getBase();

  if (f !== 0) {
    writer.writeUint32(20, f);
  }
};
/**
 * optional uint64 trade_height = 1;
 * @return {number}
 */


proto.bcsdk.MakerOrderInfo.prototype.getTradeHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MakerOrderInfo.prototype.setTradeHeight = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint64 deposit = 2;
 * @return {number}
 */


proto.bcsdk.MakerOrderInfo.prototype.getDeposit = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MakerOrderInfo.prototype.setDeposit = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint64 settlement = 3;
 * @return {number}
 */


proto.bcsdk.MakerOrderInfo.prototype.getSettlement = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MakerOrderInfo.prototype.setSettlement = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional uint64 shift_maker = 4;
 * @return {number}
 */


proto.bcsdk.MakerOrderInfo.prototype.getShiftMaker = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MakerOrderInfo.prototype.setShiftMaker = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional uint64 shift_taker = 5;
 * @return {number}
 */


proto.bcsdk.MakerOrderInfo.prototype.getShiftTaker = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MakerOrderInfo.prototype.setShiftTaker = function (value) {
  jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string sends_from_chain = 6;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getSendsFromChain = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setSendsFromChain = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string receives_to_chain = 7;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getReceivesToChain = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setReceivesToChain = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string sends_from_address = 8;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getSendsFromAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 8, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setSendsFromAddress = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string receives_to_address = 9;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getReceivesToAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 9, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setReceivesToAddress = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string sends_unit = 10;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getSendsUnit = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 10, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setSendsUnit = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string receives_unit = 11;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getReceivesUnit = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 11, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setReceivesUnit = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string double_hashed_bc_address = 12;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getDoubleHashedBcAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 12, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setDoubleHashedBcAddress = function (value) {
  jspb.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string collateralized_nrg = 13;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getCollateralizedNrg = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 13, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setCollateralizedNrg = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string original_nrg = 14;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getOriginalNrg = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 14, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setOriginalNrg = function (value) {
  jspb.Message.setProto3StringField(this, 14, value);
};
/**
 * optional string nrg_unit = 15;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getNrgUnit = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 15, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setNrgUnit = function (value) {
  jspb.Message.setProto3StringField(this, 15, value);
};
/**
 * optional string tx_hash = 16;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getTxHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 16, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setTxHash = function (value) {
  jspb.Message.setProto3StringField(this, 16, value);
};
/**
 * optional uint32 tx_output_index = 17;
 * @return {number}
 */


proto.bcsdk.MakerOrderInfo.prototype.getTxOutputIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 17, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MakerOrderInfo.prototype.setTxOutputIndex = function (value) {
  jspb.Message.setProto3IntField(this, 17, value);
};
/**
 * optional bool is_settled = 18;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */


proto.bcsdk.MakerOrderInfo.prototype.getIsSettled = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getFieldWithDefault(this, 18, false)
  );
};
/** @param {boolean} value */


proto.bcsdk.MakerOrderInfo.prototype.setIsSettled = function (value) {
  jspb.Message.setProto3BooleanField(this, 18, value);
};
/**
 * optional string fixed_unit_fee = 19;
 * @return {string}
 */


proto.bcsdk.MakerOrderInfo.prototype.getFixedUnitFee = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 19, "")
  );
};
/** @param {string} value */


proto.bcsdk.MakerOrderInfo.prototype.setFixedUnitFee = function (value) {
  jspb.Message.setProto3StringField(this, 19, value);
};
/**
 * optional uint32 base = 20;
 * @return {number}
 */


proto.bcsdk.MakerOrderInfo.prototype.getBase = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 20, 0)
  );
};
/** @param {number} value */


proto.bcsdk.MakerOrderInfo.prototype.setBase = function (value) {
  jspb.Message.setProto3IntField(this, 20, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.TakerOrderInfo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.TakerOrderInfo, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.TakerOrderInfo.displayName = 'proto.bcsdk.TakerOrderInfo';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.TakerOrderInfo.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.TakerOrderInfo.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.TakerOrderInfo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.TakerOrderInfo.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      sendsFromAddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
      receivesToAddress: jspb.Message.getFieldWithDefault(msg, 2, ""),
      doubleHashedBcAddress: jspb.Message.getFieldWithDefault(msg, 3, ""),
      isSettled: jspb.Message.getFieldWithDefault(msg, 4, false),
      txHash: jspb.Message.getFieldWithDefault(msg, 5, ""),
      txOutputIndex: jspb.Message.getFieldWithDefault(msg, 6, 0),
      totalCollateral: jspb.Message.getFieldWithDefault(msg, 7, ""),
      tradeHeight: jspb.Message.getFieldWithDefault(msg, 8, 0),
      timestamp: jspb.Message.getFieldWithDefault(msg, 9, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.TakerOrderInfo}
 */


proto.bcsdk.TakerOrderInfo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.TakerOrderInfo();
  return proto.bcsdk.TakerOrderInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.TakerOrderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.TakerOrderInfo}
 */


proto.bcsdk.TakerOrderInfo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSendsFromAddress(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setReceivesToAddress(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDoubleHashedBcAddress(value);
        break;

      case 4:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsSettled(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTxHash(value);
        break;

      case 6:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setTxOutputIndex(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTotalCollateral(value);
        break;

      case 8:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTradeHeight(value);
        break;

      case 9:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setTimestamp(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.TakerOrderInfo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.TakerOrderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.TakerOrderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.TakerOrderInfo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSendsFromAddress();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getReceivesToAddress();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getDoubleHashedBcAddress();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getIsSettled();

  if (f) {
    writer.writeBool(4, f);
  }

  f = message.getTxHash();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getTxOutputIndex();

  if (f !== 0) {
    writer.writeUint32(6, f);
  }

  f = message.getTotalCollateral();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getTradeHeight();

  if (f !== 0) {
    writer.writeUint64(8, f);
  }

  f = message.getTimestamp();

  if (f !== 0) {
    writer.writeUint64(9, f);
  }
};
/**
 * optional string sends_from_address = 1;
 * @return {string}
 */


proto.bcsdk.TakerOrderInfo.prototype.getSendsFromAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.TakerOrderInfo.prototype.setSendsFromAddress = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string receives_to_address = 2;
 * @return {string}
 */


proto.bcsdk.TakerOrderInfo.prototype.getReceivesToAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.TakerOrderInfo.prototype.setReceivesToAddress = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string double_hashed_bc_address = 3;
 * @return {string}
 */


proto.bcsdk.TakerOrderInfo.prototype.getDoubleHashedBcAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.TakerOrderInfo.prototype.setDoubleHashedBcAddress = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional bool is_settled = 4;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */


proto.bcsdk.TakerOrderInfo.prototype.getIsSettled = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getFieldWithDefault(this, 4, false)
  );
};
/** @param {boolean} value */


proto.bcsdk.TakerOrderInfo.prototype.setIsSettled = function (value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};
/**
 * optional string tx_hash = 5;
 * @return {string}
 */


proto.bcsdk.TakerOrderInfo.prototype.getTxHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.bcsdk.TakerOrderInfo.prototype.setTxHash = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional uint32 tx_output_index = 6;
 * @return {number}
 */


proto.bcsdk.TakerOrderInfo.prototype.getTxOutputIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {number} value */


proto.bcsdk.TakerOrderInfo.prototype.setTxOutputIndex = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional string total_collateral = 7;
 * @return {string}
 */


proto.bcsdk.TakerOrderInfo.prototype.getTotalCollateral = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/** @param {string} value */


proto.bcsdk.TakerOrderInfo.prototype.setTotalCollateral = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional uint64 trade_height = 8;
 * @return {number}
 */


proto.bcsdk.TakerOrderInfo.prototype.getTradeHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 8, 0)
  );
};
/** @param {number} value */


proto.bcsdk.TakerOrderInfo.prototype.setTradeHeight = function (value) {
  jspb.Message.setProto3IntField(this, 8, value);
};
/**
 * optional uint64 timestamp = 9;
 * @return {number}
 */


proto.bcsdk.TakerOrderInfo.prototype.getTimestamp = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 9, 0)
  );
};
/** @param {number} value */


proto.bcsdk.TakerOrderInfo.prototype.setTimestamp = function (value) {
  jspb.Message.setProto3IntField(this, 9, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.MatchedOrderInfo = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.MatchedOrderInfo, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.MatchedOrderInfo.displayName = 'proto.bcsdk.MatchedOrderInfo';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.MatchedOrderInfo.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.MatchedOrderInfo.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.MatchedOrderInfo} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.MatchedOrderInfo.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      maker: (f = msg.getMaker()) && proto.bcsdk.MakerOrderInfo.toObject(includeInstance, f),
      taker: (f = msg.getTaker()) && proto.bcsdk.TakerOrderInfo.toObject(includeInstance, f),
      unlocked: jspb.Message.getFieldWithDefault(msg, 7, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.MatchedOrderInfo}
 */


proto.bcsdk.MatchedOrderInfo.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.MatchedOrderInfo();
  return proto.bcsdk.MatchedOrderInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.MatchedOrderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.MatchedOrderInfo}
 */


proto.bcsdk.MatchedOrderInfo.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.MakerOrderInfo();
        reader.readMessage(value, proto.bcsdk.MakerOrderInfo.deserializeBinaryFromReader);
        msg.setMaker(value);
        break;

      case 2:
        var value = new proto.bcsdk.TakerOrderInfo();
        reader.readMessage(value, proto.bcsdk.TakerOrderInfo.deserializeBinaryFromReader);
        msg.setTaker(value);
        break;

      case 7:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setUnlocked(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.MatchedOrderInfo.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.MatchedOrderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.MatchedOrderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.MatchedOrderInfo.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getMaker();

  if (f != null) {
    writer.writeMessage(1, f, proto.bcsdk.MakerOrderInfo.serializeBinaryToWriter);
  }

  f = message.getTaker();

  if (f != null) {
    writer.writeMessage(2, f, proto.bcsdk.TakerOrderInfo.serializeBinaryToWriter);
  }

  f = message.getUnlocked();

  if (f) {
    writer.writeBool(7, f);
  }
};
/**
 * optional MakerOrderInfo maker = 1;
 * @return {?proto.bcsdk.MakerOrderInfo}
 */


proto.bcsdk.MatchedOrderInfo.prototype.getMaker = function () {
  return (
    /** @type{?proto.bcsdk.MakerOrderInfo} */
    jspb.Message.getWrapperField(this, proto.bcsdk.MakerOrderInfo, 1)
  );
};
/** @param {?proto.bcsdk.MakerOrderInfo|undefined} value */


proto.bcsdk.MatchedOrderInfo.prototype.setMaker = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};

proto.bcsdk.MatchedOrderInfo.prototype.clearMaker = function () {
  this.setMaker(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.bcsdk.MatchedOrderInfo.prototype.hasMaker = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional TakerOrderInfo taker = 2;
 * @return {?proto.bcsdk.TakerOrderInfo}
 */


proto.bcsdk.MatchedOrderInfo.prototype.getTaker = function () {
  return (
    /** @type{?proto.bcsdk.TakerOrderInfo} */
    jspb.Message.getWrapperField(this, proto.bcsdk.TakerOrderInfo, 2)
  );
};
/** @param {?proto.bcsdk.TakerOrderInfo|undefined} value */


proto.bcsdk.MatchedOrderInfo.prototype.setTaker = function (value) {
  jspb.Message.setWrapperField(this, 2, value);
};

proto.bcsdk.MatchedOrderInfo.prototype.clearTaker = function () {
  this.setTaker(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.bcsdk.MatchedOrderInfo.prototype.hasTaker = function () {
  return jspb.Message.getField(this, 2) != null;
};
/**
 * optional bool unlocked = 7;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */


proto.bcsdk.MatchedOrderInfo.prototype.getUnlocked = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getFieldWithDefault(this, 7, false)
  );
};
/** @param {boolean} value */


proto.bcsdk.MatchedOrderInfo.prototype.setUnlocked = function (value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetOpenOrdersResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.GetOpenOrdersResponse.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.GetOpenOrdersResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetOpenOrdersResponse.displayName = 'proto.bcsdk.GetOpenOrdersResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.GetOpenOrdersResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetOpenOrdersResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetOpenOrdersResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetOpenOrdersResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetOpenOrdersResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      ordersList: jspb.Message.toObjectList(msg.getOrdersList(), proto.bcsdk.MakerOrderInfo.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetOpenOrdersResponse}
 */


proto.bcsdk.GetOpenOrdersResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetOpenOrdersResponse();
  return proto.bcsdk.GetOpenOrdersResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetOpenOrdersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetOpenOrdersResponse}
 */


proto.bcsdk.GetOpenOrdersResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.MakerOrderInfo();
        reader.readMessage(value, proto.bcsdk.MakerOrderInfo.deserializeBinaryFromReader);
        msg.addOrders(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetOpenOrdersResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetOpenOrdersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetOpenOrdersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetOpenOrdersResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrdersList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.bcsdk.MakerOrderInfo.serializeBinaryToWriter);
  }
};
/**
 * repeated MakerOrderInfo orders = 1;
 * @return {!Array<!proto.bcsdk.MakerOrderInfo>}
 */


proto.bcsdk.GetOpenOrdersResponse.prototype.getOrdersList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.MakerOrderInfo>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.MakerOrderInfo, 1)
  );
};
/** @param {!Array<!proto.bcsdk.MakerOrderInfo>} value */


proto.bcsdk.GetOpenOrdersResponse.prototype.setOrdersList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.bcsdk.MakerOrderInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.MakerOrderInfo}
 */


proto.bcsdk.GetOpenOrdersResponse.prototype.addOrders = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.bcsdk.MakerOrderInfo, opt_index);
};

proto.bcsdk.GetOpenOrdersResponse.prototype.clearOrdersList = function () {
  this.setOrdersList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetMatchedOrdersResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.GetMatchedOrdersResponse.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.GetMatchedOrdersResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetMatchedOrdersResponse.displayName = 'proto.bcsdk.GetMatchedOrdersResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.GetMatchedOrdersResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetMatchedOrdersResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetMatchedOrdersResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetMatchedOrdersResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetMatchedOrdersResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      ordersList: jspb.Message.toObjectList(msg.getOrdersList(), proto.bcsdk.MatchedOrderInfo.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetMatchedOrdersResponse}
 */


proto.bcsdk.GetMatchedOrdersResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetMatchedOrdersResponse();
  return proto.bcsdk.GetMatchedOrdersResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetMatchedOrdersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetMatchedOrdersResponse}
 */


proto.bcsdk.GetMatchedOrdersResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.MatchedOrderInfo();
        reader.readMessage(value, proto.bcsdk.MatchedOrderInfo.deserializeBinaryFromReader);
        msg.addOrders(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetMatchedOrdersResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetMatchedOrdersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetMatchedOrdersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetMatchedOrdersResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrdersList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.bcsdk.MatchedOrderInfo.serializeBinaryToWriter);
  }
};
/**
 * repeated MatchedOrderInfo orders = 1;
 * @return {!Array<!proto.bcsdk.MatchedOrderInfo>}
 */


proto.bcsdk.GetMatchedOrdersResponse.prototype.getOrdersList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.MatchedOrderInfo>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.MatchedOrderInfo, 1)
  );
};
/** @param {!Array<!proto.bcsdk.MatchedOrderInfo>} value */


proto.bcsdk.GetMatchedOrdersResponse.prototype.setOrdersList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.bcsdk.MatchedOrderInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.MatchedOrderInfo}
 */


proto.bcsdk.GetMatchedOrdersResponse.prototype.addOrders = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.bcsdk.MatchedOrderInfo, opt_index);
};

proto.bcsdk.GetMatchedOrdersResponse.prototype.clearOrdersList = function () {
  this.setOrdersList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetHistoricalOrdersResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.GetHistoricalOrdersResponse.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.GetHistoricalOrdersResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetHistoricalOrdersResponse.displayName = 'proto.bcsdk.GetHistoricalOrdersResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.GetHistoricalOrdersResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetHistoricalOrdersResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetHistoricalOrdersResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetHistoricalOrdersResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetHistoricalOrdersResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      ordersList: jspb.Message.toObjectList(msg.getOrdersList(), proto.bcsdk.MatchedOrderInfo.toObject, includeInstance),
      nextBlock: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetHistoricalOrdersResponse}
 */


proto.bcsdk.GetHistoricalOrdersResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetHistoricalOrdersResponse();
  return proto.bcsdk.GetHistoricalOrdersResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetHistoricalOrdersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetHistoricalOrdersResponse}
 */


proto.bcsdk.GetHistoricalOrdersResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.bcsdk.MatchedOrderInfo();
        reader.readMessage(value, proto.bcsdk.MatchedOrderInfo.deserializeBinaryFromReader);
        msg.addOrders(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint64();
        msg.setNextBlock(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetHistoricalOrdersResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetHistoricalOrdersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetHistoricalOrdersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetHistoricalOrdersResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getOrdersList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.bcsdk.MatchedOrderInfo.serializeBinaryToWriter);
  }

  f = message.getNextBlock();

  if (f !== 0) {
    writer.writeUint64(2, f);
  }
};
/**
 * repeated MatchedOrderInfo orders = 1;
 * @return {!Array<!proto.bcsdk.MatchedOrderInfo>}
 */


proto.bcsdk.GetHistoricalOrdersResponse.prototype.getOrdersList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.MatchedOrderInfo>} */
    jspb.Message.getRepeatedWrapperField(this, proto.bcsdk.MatchedOrderInfo, 1)
  );
};
/** @param {!Array<!proto.bcsdk.MatchedOrderInfo>} value */


proto.bcsdk.GetHistoricalOrdersResponse.prototype.setOrdersList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.bcsdk.MatchedOrderInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.MatchedOrderInfo}
 */


proto.bcsdk.GetHistoricalOrdersResponse.prototype.addOrders = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.bcsdk.MatchedOrderInfo, opt_index);
};

proto.bcsdk.GetHistoricalOrdersResponse.prototype.clearOrdersList = function () {
  this.setOrdersList([]);
};
/**
 * optional uint64 next_block = 2;
 * @return {number}
 */


proto.bcsdk.GetHistoricalOrdersResponse.prototype.getNextBlock = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetHistoricalOrdersResponse.prototype.setNextBlock = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.TakerOrder = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.TakerOrder, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.TakerOrder.displayName = 'proto.bcsdk.TakerOrder';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.TakerOrder.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.TakerOrder.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.TakerOrder} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.TakerOrder.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      sendsFromAddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
      receivesToAddress: jspb.Message.getFieldWithDefault(msg, 2, ""),
      makerTxHash: jspb.Message.getFieldWithDefault(msg, 3, ""),
      makerTxOutputIndex: jspb.Message.getFieldWithDefault(msg, 4, 0),
      collateralizedNrg: jspb.Message.getFieldWithDefault(msg, 5, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.TakerOrder}
 */


proto.bcsdk.TakerOrder.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.TakerOrder();
  return proto.bcsdk.TakerOrder.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.TakerOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.TakerOrder}
 */


proto.bcsdk.TakerOrder.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setSendsFromAddress(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setReceivesToAddress(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setMakerTxHash(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setMakerTxOutputIndex(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setCollateralizedNrg(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.TakerOrder.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.TakerOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.TakerOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.TakerOrder.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSendsFromAddress();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getReceivesToAddress();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getMakerTxHash();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getMakerTxOutputIndex();

  if (f !== 0) {
    writer.writeUint32(4, f);
  }

  f = message.getCollateralizedNrg();

  if (f.length > 0) {
    writer.writeString(5, f);
  }
};
/**
 * optional string sends_from_address = 1;
 * @return {string}
 */


proto.bcsdk.TakerOrder.prototype.getSendsFromAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.TakerOrder.prototype.setSendsFromAddress = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string receives_to_address = 2;
 * @return {string}
 */


proto.bcsdk.TakerOrder.prototype.getReceivesToAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.TakerOrder.prototype.setReceivesToAddress = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string maker_tx_hash = 3;
 * @return {string}
 */


proto.bcsdk.TakerOrder.prototype.getMakerTxHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.bcsdk.TakerOrder.prototype.setMakerTxHash = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional uint32 maker_tx_output_index = 4;
 * @return {number}
 */


proto.bcsdk.TakerOrder.prototype.getMakerTxOutputIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {number} value */


proto.bcsdk.TakerOrder.prototype.setMakerTxOutputIndex = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string collateralized_nrg = 5;
 * @return {string}
 */


proto.bcsdk.TakerOrder.prototype.getCollateralizedNrg = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.bcsdk.TakerOrder.prototype.setCollateralizedNrg = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetBlake2blRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetBlake2blRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetBlake2blRequest.displayName = 'proto.bcsdk.GetBlake2blRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetBlake2blRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetBlake2blRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetBlake2blRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetBlake2blRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      toBeHashed: jspb.Message.getFieldWithDefault(msg, 1, ""),
      times: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetBlake2blRequest}
 */


proto.bcsdk.GetBlake2blRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetBlake2blRequest();
  return proto.bcsdk.GetBlake2blRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetBlake2blRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetBlake2blRequest}
 */


proto.bcsdk.GetBlake2blRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setToBeHashed(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setTimes(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetBlake2blRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetBlake2blRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetBlake2blRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetBlake2blRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getToBeHashed();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getTimes();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }
};
/**
 * optional string to_be_hashed = 1;
 * @return {string}
 */


proto.bcsdk.GetBlake2blRequest.prototype.getToBeHashed = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetBlake2blRequest.prototype.setToBeHashed = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 times = 2;
 * @return {number}
 */


proto.bcsdk.GetBlake2blRequest.prototype.getTimes = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetBlake2blRequest.prototype.setTimes = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetBlake2blResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetBlake2blResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetBlake2blResponse.displayName = 'proto.bcsdk.GetBlake2blResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetBlake2blResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetBlake2blResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetBlake2blResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetBlake2blResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      hash: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetBlake2blResponse}
 */


proto.bcsdk.GetBlake2blResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetBlake2blResponse();
  return proto.bcsdk.GetBlake2blResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetBlake2blResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetBlake2blResponse}
 */


proto.bcsdk.GetBlake2blResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetBlake2blResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetBlake2blResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetBlake2blResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetBlake2blResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string hash = 1;
 * @return {string}
 */


proto.bcsdk.GetBlake2blResponse.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetBlake2blResponse.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.VanityConvertRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.VanityConvertRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.VanityConvertRequest.displayName = 'proto.bcsdk.VanityConvertRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.VanityConvertRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.VanityConvertRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.VanityConvertRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.VanityConvertRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      vanity: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.VanityConvertRequest}
 */


proto.bcsdk.VanityConvertRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.VanityConvertRequest();
  return proto.bcsdk.VanityConvertRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.VanityConvertRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.VanityConvertRequest}
 */


proto.bcsdk.VanityConvertRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setVanity(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.VanityConvertRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.VanityConvertRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.VanityConvertRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.VanityConvertRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getVanity();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string vanity = 1;
 * @return {string}
 */


proto.bcsdk.VanityConvertRequest.prototype.getVanity = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.VanityConvertRequest.prototype.setVanity = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.VanityConvertResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.VanityConvertResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.VanityConvertResponse.displayName = 'proto.bcsdk.VanityConvertResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.VanityConvertResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.VanityConvertResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.VanityConvertResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.VanityConvertResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      bcAddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
      error: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.VanityConvertResponse}
 */


proto.bcsdk.VanityConvertResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.VanityConvertResponse();
  return proto.bcsdk.VanityConvertResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.VanityConvertResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.VanityConvertResponse}
 */


proto.bcsdk.VanityConvertResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBcAddress(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setError(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.VanityConvertResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.VanityConvertResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.VanityConvertResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.VanityConvertResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBcAddress();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getError();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string bc_address = 1;
 * @return {string}
 */


proto.bcsdk.VanityConvertResponse.prototype.getBcAddress = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.VanityConvertResponse.prototype.setBcAddress = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string error = 2;
 * @return {string}
 */


proto.bcsdk.VanityConvertResponse.prototype.getError = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.VanityConvertResponse.prototype.setError = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetRoveredBlockHashRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetRoveredBlockHashRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetRoveredBlockHashRequest.displayName = 'proto.bcsdk.GetRoveredBlockHashRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetRoveredBlockHashRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetRoveredBlockHashRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetRoveredBlockHashRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetRoveredBlockHashRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      blockchain: jspb.Message.getFieldWithDefault(msg, 1, ""),
      hash: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetRoveredBlockHashRequest}
 */


proto.bcsdk.GetRoveredBlockHashRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetRoveredBlockHashRequest();
  return proto.bcsdk.GetRoveredBlockHashRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetRoveredBlockHashRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetRoveredBlockHashRequest}
 */


proto.bcsdk.GetRoveredBlockHashRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBlockchain(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetRoveredBlockHashRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetRoveredBlockHashRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetRoveredBlockHashRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetRoveredBlockHashRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBlockchain();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string blockchain = 1;
 * @return {string}
 */


proto.bcsdk.GetRoveredBlockHashRequest.prototype.getBlockchain = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetRoveredBlockHashRequest.prototype.setBlockchain = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string hash = 2;
 * @return {string}
 */


proto.bcsdk.GetRoveredBlockHashRequest.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetRoveredBlockHashRequest.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetRoveredBlockHeightRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetRoveredBlockHeightRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetRoveredBlockHeightRequest.displayName = 'proto.bcsdk.GetRoveredBlockHeightRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetRoveredBlockHeightRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetRoveredBlockHeightRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetRoveredBlockHeightRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetRoveredBlockHeightRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      blockchain: jspb.Message.getFieldWithDefault(msg, 1, ""),
      height: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetRoveredBlockHeightRequest}
 */


proto.bcsdk.GetRoveredBlockHeightRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetRoveredBlockHeightRequest();
  return proto.bcsdk.GetRoveredBlockHeightRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetRoveredBlockHeightRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetRoveredBlockHeightRequest}
 */


proto.bcsdk.GetRoveredBlockHeightRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBlockchain(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setHeight(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetRoveredBlockHeightRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetRoveredBlockHeightRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetRoveredBlockHeightRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetRoveredBlockHeightRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBlockchain();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getHeight();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }
};
/**
 * optional string blockchain = 1;
 * @return {string}
 */


proto.bcsdk.GetRoveredBlockHeightRequest.prototype.getBlockchain = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetRoveredBlockHeightRequest.prototype.setBlockchain = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 height = 2;
 * @return {number}
 */


proto.bcsdk.GetRoveredBlockHeightRequest.prototype.getHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetRoveredBlockHeightRequest.prototype.setHeight = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetBlockHashRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetBlockHashRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetBlockHashRequest.displayName = 'proto.bcsdk.GetBlockHashRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetBlockHashRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetBlockHashRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetBlockHashRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetBlockHashRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      hash: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetBlockHashRequest}
 */


proto.bcsdk.GetBlockHashRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetBlockHashRequest();
  return proto.bcsdk.GetBlockHashRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetBlockHashRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetBlockHashRequest}
 */


proto.bcsdk.GetBlockHashRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetBlockHashRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetBlockHashRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetBlockHashRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetBlockHashRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string hash = 1;
 * @return {string}
 */


proto.bcsdk.GetBlockHashRequest.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetBlockHashRequest.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetBlockHeightRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetBlockHeightRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetBlockHeightRequest.displayName = 'proto.bcsdk.GetBlockHeightRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetBlockHeightRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetBlockHeightRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetBlockHeightRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetBlockHeightRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      height: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetBlockHeightRequest}
 */


proto.bcsdk.GetBlockHeightRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetBlockHeightRequest();
  return proto.bcsdk.GetBlockHeightRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetBlockHeightRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetBlockHeightRequest}
 */


proto.bcsdk.GetBlockHeightRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setHeight(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetBlockHeightRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetBlockHeightRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetBlockHeightRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetBlockHeightRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHeight();

  if (f !== 0) {
    writer.writeUint32(1, f);
  }
};
/**
 * optional uint32 height = 1;
 * @return {number}
 */


proto.bcsdk.GetBlockHeightRequest.prototype.getHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetBlockHeightRequest.prototype.setHeight = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetBlocksRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetBlocksRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetBlocksRequest.displayName = 'proto.bcsdk.GetBlocksRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetBlocksRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetBlocksRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetBlocksRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetBlocksRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      startHeight: jspb.Message.getFieldWithDefault(msg, 1, 0),
      endHeight: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetBlocksRequest}
 */


proto.bcsdk.GetBlocksRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetBlocksRequest();
  return proto.bcsdk.GetBlocksRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetBlocksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetBlocksRequest}
 */


proto.bcsdk.GetBlocksRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setStartHeight(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setEndHeight(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetBlocksRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetBlocksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetBlocksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetBlocksRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStartHeight();

  if (f !== 0) {
    writer.writeUint32(1, f);
  }

  f = message.getEndHeight();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }
};
/**
 * optional uint32 start_height = 1;
 * @return {number}
 */


proto.bcsdk.GetBlocksRequest.prototype.getStartHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetBlocksRequest.prototype.setStartHeight = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 end_height = 2;
 * @return {number}
 */


proto.bcsdk.GetBlocksRequest.prototype.getEndHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetBlocksRequest.prototype.setEndHeight = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetBlocksResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.GetBlocksResponse.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.GetBlocksResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetBlocksResponse.displayName = 'proto.bcsdk.GetBlocksResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.GetBlocksResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetBlocksResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetBlocksResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetBlocksResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetBlocksResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      blocksList: jspb.Message.toObjectList(msg.getBlocksList(), core_pb.BcBlock.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetBlocksResponse}
 */


proto.bcsdk.GetBlocksResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetBlocksResponse();
  return proto.bcsdk.GetBlocksResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetBlocksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetBlocksResponse}
 */


proto.bcsdk.GetBlocksResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new core_pb.BcBlock();
        reader.readMessage(value, core_pb.BcBlock.deserializeBinaryFromReader);
        msg.addBlocks(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetBlocksResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetBlocksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetBlocksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetBlocksResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBlocksList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, core_pb.BcBlock.serializeBinaryToWriter);
  }
};
/**
 * repeated BcBlock blocks = 1;
 * @return {!Array<!proto.bcsdk.BcBlock>}
 */


proto.bcsdk.GetBlocksResponse.prototype.getBlocksList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.BcBlock>} */
    jspb.Message.getRepeatedWrapperField(this, core_pb.BcBlock, 1)
  );
};
/** @param {!Array<!proto.bcsdk.BcBlock>} value */


proto.bcsdk.GetBlocksResponse.prototype.setBlocksList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.bcsdk.BcBlock=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.BcBlock}
 */


proto.bcsdk.GetBlocksResponse.prototype.addBlocks = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.bcsdk.BcBlock, opt_index);
};

proto.bcsdk.GetBlocksResponse.prototype.clearBlocksList = function () {
  this.setBlocksList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetRoveredBlocksRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetRoveredBlocksRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetRoveredBlocksRequest.displayName = 'proto.bcsdk.GetRoveredBlocksRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetRoveredBlocksRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetRoveredBlocksRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetRoveredBlocksRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetRoveredBlocksRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      blockchain: jspb.Message.getFieldWithDefault(msg, 1, ""),
      startHeight: jspb.Message.getFieldWithDefault(msg, 2, 0),
      endHeight: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetRoveredBlocksRequest}
 */


proto.bcsdk.GetRoveredBlocksRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetRoveredBlocksRequest();
  return proto.bcsdk.GetRoveredBlocksRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetRoveredBlocksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetRoveredBlocksRequest}
 */


proto.bcsdk.GetRoveredBlocksRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBlockchain(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setStartHeight(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setEndHeight(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetRoveredBlocksRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetRoveredBlocksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetRoveredBlocksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetRoveredBlocksRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBlockchain();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getStartHeight();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }

  f = message.getEndHeight();

  if (f !== 0) {
    writer.writeUint32(3, f);
  }
};
/**
 * optional string blockchain = 1;
 * @return {string}
 */


proto.bcsdk.GetRoveredBlocksRequest.prototype.getBlockchain = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetRoveredBlocksRequest.prototype.setBlockchain = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 start_height = 2;
 * @return {number}
 */


proto.bcsdk.GetRoveredBlocksRequest.prototype.getStartHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetRoveredBlocksRequest.prototype.setStartHeight = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint32 end_height = 3;
 * @return {number}
 */


proto.bcsdk.GetRoveredBlocksRequest.prototype.getEndHeight = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetRoveredBlocksRequest.prototype.setEndHeight = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetRawMempoolResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.GetRawMempoolResponse.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.GetRawMempoolResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetRawMempoolResponse.displayName = 'proto.bcsdk.GetRawMempoolResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.GetRawMempoolResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetRawMempoolResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetRawMempoolResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetRawMempoolResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetRawMempoolResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(), core_pb.Transaction.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetRawMempoolResponse}
 */


proto.bcsdk.GetRawMempoolResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetRawMempoolResponse();
  return proto.bcsdk.GetRawMempoolResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetRawMempoolResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetRawMempoolResponse}
 */


proto.bcsdk.GetRawMempoolResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new core_pb.Transaction();
        reader.readMessage(value, core_pb.Transaction.deserializeBinaryFromReader);
        msg.addTransactions(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetRawMempoolResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetRawMempoolResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetRawMempoolResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetRawMempoolResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTransactionsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, core_pb.Transaction.serializeBinaryToWriter);
  }
};
/**
 * repeated Transaction transactions = 1;
 * @return {!Array<!proto.bcsdk.Transaction>}
 */


proto.bcsdk.GetRawMempoolResponse.prototype.getTransactionsList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.Transaction>} */
    jspb.Message.getRepeatedWrapperField(this, core_pb.Transaction, 1)
  );
};
/** @param {!Array<!proto.bcsdk.Transaction>} value */


proto.bcsdk.GetRawMempoolResponse.prototype.setTransactionsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.bcsdk.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.Transaction}
 */


proto.bcsdk.GetRawMempoolResponse.prototype.addTransactions = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.bcsdk.Transaction, opt_index);
};

proto.bcsdk.GetRawMempoolResponse.prototype.clearTransactionsList = function () {
  this.setTransactionsList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetRoveredBlocksResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.bcsdk.GetRoveredBlocksResponse.repeatedFields_, null);
};

goog.inherits(proto.bcsdk.GetRoveredBlocksResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetRoveredBlocksResponse.displayName = 'proto.bcsdk.GetRoveredBlocksResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.bcsdk.GetRoveredBlocksResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetRoveredBlocksResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetRoveredBlocksResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetRoveredBlocksResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetRoveredBlocksResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      blocksList: jspb.Message.toObjectList(msg.getBlocksList(), core_pb.Block.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetRoveredBlocksResponse}
 */


proto.bcsdk.GetRoveredBlocksResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetRoveredBlocksResponse();
  return proto.bcsdk.GetRoveredBlocksResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetRoveredBlocksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetRoveredBlocksResponse}
 */


proto.bcsdk.GetRoveredBlocksResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new core_pb.Block();
        reader.readMessage(value, core_pb.Block.deserializeBinaryFromReader);
        msg.addBlocks(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetRoveredBlocksResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetRoveredBlocksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetRoveredBlocksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetRoveredBlocksResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBlocksList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, core_pb.Block.serializeBinaryToWriter);
  }
};
/**
 * repeated Block blocks = 1;
 * @return {!Array<!proto.bcsdk.Block>}
 */


proto.bcsdk.GetRoveredBlocksResponse.prototype.getBlocksList = function () {
  return (
    /** @type{!Array<!proto.bcsdk.Block>} */
    jspb.Message.getRepeatedWrapperField(this, core_pb.Block, 1)
  );
};
/** @param {!Array<!proto.bcsdk.Block>} value */


proto.bcsdk.GetRoveredBlocksResponse.prototype.setBlocksList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.bcsdk.Block=} opt_value
 * @param {number=} opt_index
 * @return {!proto.bcsdk.Block}
 */


proto.bcsdk.GetRoveredBlocksResponse.prototype.addBlocks = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.bcsdk.Block, opt_index);
};

proto.bcsdk.GetRoveredBlocksResponse.prototype.clearBlocksList = function () {
  this.setBlocksList([]);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetTxRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetTxRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetTxRequest.displayName = 'proto.bcsdk.GetTxRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetTxRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetTxRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetTxRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetTxRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      hash: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetTxRequest}
 */


proto.bcsdk.GetTxRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetTxRequest();
  return proto.bcsdk.GetTxRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetTxRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetTxRequest}
 */


proto.bcsdk.GetTxRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetTxRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetTxRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetTxRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetTxRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string hash = 1;
 * @return {string}
 */


proto.bcsdk.GetTxRequest.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetTxRequest.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetMarkedTxRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetMarkedTxRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetMarkedTxRequest.displayName = 'proto.bcsdk.GetMarkedTxRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetMarkedTxRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetMarkedTxRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetMarkedTxRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetMarkedTxRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      blockchain: jspb.Message.getFieldWithDefault(msg, 1, ""),
      hash: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetMarkedTxRequest}
 */


proto.bcsdk.GetMarkedTxRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetMarkedTxRequest();
  return proto.bcsdk.GetMarkedTxRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetMarkedTxRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetMarkedTxRequest}
 */


proto.bcsdk.GetMarkedTxRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBlockchain(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetMarkedTxRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetMarkedTxRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetMarkedTxRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetMarkedTxRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getBlockchain();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string blockchain = 1;
 * @return {string}
 */


proto.bcsdk.GetMarkedTxRequest.prototype.getBlockchain = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetMarkedTxRequest.prototype.setBlockchain = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string hash = 2;
 * @return {string}
 */


proto.bcsdk.GetMarkedTxRequest.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetMarkedTxRequest.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetOutPointRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetOutPointRequest, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetOutPointRequest.displayName = 'proto.bcsdk.GetOutPointRequest';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetOutPointRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetOutPointRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetOutPointRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetOutPointRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
      index: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetOutPointRequest}
 */


proto.bcsdk.GetOutPointRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetOutPointRequest();
  return proto.bcsdk.GetOutPointRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetOutPointRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetOutPointRequest}
 */


proto.bcsdk.GetOutPointRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setHash(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setIndex(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetOutPointRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetOutPointRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetOutPointRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetOutPointRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getHash();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getIndex();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }
};
/**
 * optional string hash = 1;
 * @return {string}
 */


proto.bcsdk.GetOutPointRequest.prototype.getHash = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.GetOutPointRequest.prototype.setHash = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 index = 2;
 * @return {number}
 */


proto.bcsdk.GetOutPointRequest.prototype.getIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetOutPointRequest.prototype.setIndex = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetTradeStatusResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetTradeStatusResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetTradeStatusResponse.displayName = 'proto.bcsdk.GetTradeStatusResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetTradeStatusResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetTradeStatusResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetTradeStatusResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetTradeStatusResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      status: jspb.Message.getFieldWithDefault(msg, 1, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetTradeStatusResponse}
 */


proto.bcsdk.GetTradeStatusResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetTradeStatusResponse();
  return proto.bcsdk.GetTradeStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetTradeStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetTradeStatusResponse}
 */


proto.bcsdk.GetTradeStatusResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setStatus(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetTradeStatusResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetTradeStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetTradeStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetTradeStatusResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStatus();

  if (f !== 0) {
    writer.writeUint32(1, f);
  }
};
/**
 * optional uint32 status = 1;
 * @return {number}
 */


proto.bcsdk.GetTradeStatusResponse.prototype.getStatus = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {number} value */


proto.bcsdk.GetTradeStatusResponse.prototype.setStatus = function (value) {
  jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.GetOutPointStatusResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.GetOutPointStatusResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.GetOutPointStatusResponse.displayName = 'proto.bcsdk.GetOutPointStatusResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.GetOutPointStatusResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.GetOutPointStatusResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.GetOutPointStatusResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.GetOutPointStatusResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      unspent: jspb.Message.getFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.GetOutPointStatusResponse}
 */


proto.bcsdk.GetOutPointStatusResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.GetOutPointStatusResponse();
  return proto.bcsdk.GetOutPointStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.GetOutPointStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.GetOutPointStatusResponse}
 */


proto.bcsdk.GetOutPointStatusResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setUnspent(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.GetOutPointStatusResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.GetOutPointStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.GetOutPointStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.GetOutPointStatusResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getUnspent();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool unspent = 1;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */


proto.bcsdk.GetOutPointStatusResponse.prototype.getUnspent = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.bcsdk.GetOutPointStatusResponse.prototype.setUnspent = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.CurrentWork = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.CurrentWork, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.CurrentWork.displayName = 'proto.bcsdk.CurrentWork';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.CurrentWork.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.CurrentWork.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.CurrentWork} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.CurrentWork.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      work: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.CurrentWork}
 */


proto.bcsdk.CurrentWork.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.CurrentWork();
  return proto.bcsdk.CurrentWork.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.CurrentWork} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.CurrentWork}
 */


proto.bcsdk.CurrentWork.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setWork(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.CurrentWork.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.CurrentWork.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.CurrentWork} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.CurrentWork.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getWork();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string work = 1;
 * @return {string}
 */


proto.bcsdk.CurrentWork.prototype.getWork = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.CurrentWork.prototype.setWork = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.SyncStatus = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.SyncStatus, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.SyncStatus.displayName = 'proto.bcsdk.SyncStatus';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.SyncStatus.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.SyncStatus.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.SyncStatus} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.SyncStatus.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      status: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.SyncStatus}
 */


proto.bcsdk.SyncStatus.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.SyncStatus();
  return proto.bcsdk.SyncStatus.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.SyncStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.SyncStatus}
 */


proto.bcsdk.SyncStatus.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStatus(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.SyncStatus.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.SyncStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.SyncStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.SyncStatus.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStatus();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string status = 1;
 * @return {string}
 */


proto.bcsdk.SyncStatus.prototype.getStatus = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.SyncStatus.prototype.setStatus = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.bcsdk.SettingsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.bcsdk.SettingsResponse, jspb.Message);

if (true || goog.DEBUG && !COMPILED) {
  proto.bcsdk.SettingsResponse.displayName = 'proto.bcsdk.SettingsResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto suitable for use in Soy templates.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
   * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
   *     for transitional soy proto support: http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.bcsdk.SettingsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.bcsdk.SettingsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Whether to include the JSPB
   *     instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.bcsdk.SettingsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.bcsdk.SettingsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      ngrokTunnel: jspb.Message.getFieldWithDefault(msg, 1, ""),
      buildVersion: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.bcsdk.SettingsResponse}
 */


proto.bcsdk.SettingsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.bcsdk.SettingsResponse();
  return proto.bcsdk.SettingsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.bcsdk.SettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.bcsdk.SettingsResponse}
 */


proto.bcsdk.SettingsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setNgrokTunnel(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setBuildVersion(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.bcsdk.SettingsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.bcsdk.SettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.bcsdk.SettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.bcsdk.SettingsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getNgrokTunnel();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getBuildVersion();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string ngrok_tunnel = 1;
 * @return {string}
 */


proto.bcsdk.SettingsResponse.prototype.getNgrokTunnel = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.bcsdk.SettingsResponse.prototype.setNgrokTunnel = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string build_version = 2;
 * @return {string}
 */


proto.bcsdk.SettingsResponse.prototype.getBuildVersion = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.bcsdk.SettingsResponse.prototype.setBuildVersion = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * @enum {number}
 */


proto.bcsdk.RpcTransactionResponseStatus = {
  SUCCESS: 0,
  FAILURE: 1
};
goog.object.extend(exports, proto.bcsdk);